module.exports = __webpack_public_path__ + "static/media/bg1.f121b4c5.jpg";